// React
import React, { useEffect, useState } from "react";

// Mui
import { Dialog, DialogContent, Box, Typography } from "@mui/material";

// Components
import PDFMediaDialog from "../PDFMediaDialog/PDFMediaDialog";
import VideoGalleryDialog from "../VideoGalleryDialog/VideoGalleryDialog";
import ImageGalleryDialog from "../ImageGalleryDialog/ImageGalleryDialog";
import LinkGalleryDialog from "../linkGalleryDialog/linkGalleryDialog";

// Asset components
import gallery from "../../assets/gallery.svg";
import video1 from "../../assets/videogallery.svg";
import pdf1 from "../../assets/pdfgallery.svg";
import link1 from "../../assets/linkgallery.svg";
import { UPLOADTYPE } from "../../models/enums/globalEnums";

type UploadTypeDialogProps = {
  open: boolean;
  onClose: () => void;

  oldMedia?: any;
  setOldMedia?: any;
  oldThumbnail?: any;
  setOldThumbnail?: any;
  gridType?: any;
  setGridType?: any;
  newMedia?: any;
  setNewMedia?: any;
  newThumbnail?: any;
  setNewThumbnail?: any;
  setgridTitle?: any;
  gridTitle?: any;
  editingIndex?: any;
  uploadLinkType?: any;
};

const UploadTypeDialog: React.FC<UploadTypeDialogProps> = ({
  open,
  onClose,
  oldMedia,
  setOldMedia,
  oldThumbnail,
  setOldThumbnail,
  gridType,
  setGridType,
  newMedia,
  setNewMedia,
  newThumbnail,
  setNewThumbnail,
  setgridTitle,
  gridTitle,
  editingIndex,
  uploadLinkType,
}) => {
  const [selectedType, setSelectedType] = useState<string | null>(null);

  const [openImageDialog1, setopenImageDialog1] = useState(false);
  const [openVideoDialog1, setopenVideoDialog1] = useState(false);
  const [openPDFDialog1, setopenPDFDialog1] = useState(false);
  const [openLinkDialog1, setopenLinkDialog1] = useState(false);

  const uploadOptions = [
    {
      label: UPLOADTYPE.IMAGES,
      icon: (
        <img src={gallery} alt="visible" style={{ width: 24, height: 24 }} />
      ),
    },
    {
      label: UPLOADTYPE.VIDEO,
      icon: (
        <img src={video1} alt="visible" style={{ width: 24, height: 24 }} />
      ),
    },
    {
      label: UPLOADTYPE.PDF,
      icon: <img src={pdf1} alt="visible" style={{ width: 24, height: 24 }} />,
    },
    ...(uploadLinkType === 1
      ? [
          {
            label: UPLOADTYPE.LINK,
            icon: (
              <img
                src={link1}
                alt="visible"
                style={{ width: 24, height: 24 }}
              />
            ),
          },
        ]
      : []),
  ];

  useEffect(() => {
    if (selectedType === UPLOADTYPE.IMAGES) {
      setopenImageDialog1(true);
    } else if (selectedType === UPLOADTYPE.VIDEO) {
      setopenVideoDialog1(true);
    } else if (selectedType === UPLOADTYPE.PDF) {
      setopenPDFDialog1(true);
    } else if (selectedType === UPLOADTYPE.LINK) {
      setopenLinkDialog1(true);
    }
  }, [selectedType]);

  const handleEmptyselectedType = () => {
    setSelectedType("");
  };
  const handleSelect = (type: string) => {
    handleEmptyselectedType();
    setSelectedType(type);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: 800, height: 225, bgcolor: "#F1F1F1", borderRadius: 2 },
      }}
    >
      <DialogContent
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          height: "100%",
          padding: "4px",
        }}
      >
        {uploadOptions.map((option) => (
          <Box
            key={option.label}
            onClick={() => handleSelect(option.label)}
            sx={{
              display: "flex",
              width: 142,
              height: 97,
              padding: "20px 57px 20px 53px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "14px",
              borderRadius: "12px",
              border: "1px solid #DCDCDC",
              background: "#e0e0e0",
              cursor: "pointer",
              "&:hover": { background: "#DCDCDC" },
            }}
          >
            {option.icon}
            <Typography
              sx={{
                color: "#000",
                fontFamily: "Inter",
                fontSize: 16,
                fontWeight: 400,
                textAlign: "center",
              }}
            >
              {option.label}
            </Typography>
          </Box>
        ))}

        <ImageGalleryDialog
          open={openImageDialog1}
          onClose={() => {
            setopenImageDialog1(false);
            onClose();
            setSelectedType("");
            // setSelectedType(null);
          }}
          // gridImages="/uploads/shared image.jfif,/uploads/imgdwn.jfif"
          // gridThumbnail="/uploads/imgdwn.jfif"
          // gridType=UPLOADTYPE.IMAGES
          // Pass other required fields here  setOldThumbnail("/uploads/imgdwn.jfif"); setOldMedia("/uploads/shared image.jfif,/uploads/imgdwn.jfif")

          oldMedia={oldMedia}
          setOldMedia={setOldMedia}
          oldThumbnail={oldThumbnail}
          setOldThumbnail={setOldThumbnail}
          gridType={gridType}
          setGridType={setGridType}
          newMedia={newMedia}
          setNewMedia={setNewMedia}
          newThumbnail={newThumbnail}
          setNewThumbnail={setNewThumbnail}
          setgridTitle={setgridTitle}
          gridTitle={gridTitle}
          editingIndex={editingIndex}
        />

        <VideoGalleryDialog
          open={openVideoDialog1}
          onClose={() => {
            setopenVideoDialog1(false);
            onClose();
            setSelectedType("");
            // setSelectedType(null);
          }}
          // "/uploads/Reality_Capture.mp4,/uploads/windsor.mp4"
          oldMedia={oldMedia}
          setOldMedia={setOldMedia}
          oldThumbnail={oldThumbnail}
          setOldThumbnail={setOldThumbnail}
          gridType={gridType}
          setGridType={setGridType}
          newMedia={newMedia}
          setNewMedia={setNewMedia}
          newThumbnail={newThumbnail}
          setNewThumbnail={setNewThumbnail}
          setgridTitle={setgridTitle}
          gridTitle={gridTitle}
          editingIndex={editingIndex}
        />
        <PDFMediaDialog
          open={openPDFDialog1}
          onClose={() => {
            setopenPDFDialog1(false);
            onClose();
            setSelectedType("");
            // setSelectedType(null);
          }}
          // "/uploads/Azure Administrator Associate.pdf,/uploads/Ashwani_KUMAR_59091.pdf"
          oldMedia={oldMedia}
          setOldMedia={setOldMedia}
          oldThumbnail={oldThumbnail}
          setOldThumbnail={setOldThumbnail}
          gridType={gridType}
          setGridType={setGridType}
          newMedia={newMedia}
          setNewMedia={setNewMedia}
          newThumbnail={newThumbnail}
          setNewThumbnail={setNewThumbnail}
          setgridTitle={setgridTitle}
          gridTitle={gridTitle}
          editingIndex={editingIndex}
        />

        <LinkGalleryDialog
          open={openLinkDialog1}
          onClose={() => {
            setopenLinkDialog1(false);
            onClose();
            setSelectedType("");
          }}
          oldMedia={oldMedia}
          setOldMedia={setOldMedia}
          oldThumbnail={oldThumbnail}
          setOldThumbnail={setOldThumbnail}
          gridType={gridType}
          setGridType={setGridType}
          newMedia={newMedia}
          setNewMedia={setNewMedia}
          newThumbnail={newThumbnail}
          setNewThumbnail={setNewThumbnail}
          setgridTitle={setgridTitle}
          gridTitle={gridTitle}
          editingIndex={editingIndex}
        />
      </DialogContent>
    </Dialog>
  );
};

export default UploadTypeDialog;
